module.exports = __webpack_public_path__ + "img/notDataImg.ed731a01.png";